import { Box, Button, Container, Grid, Hidden, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { boxShadow, colors } from "swyft-react-core";
import OverrideTheme from "../../components/OverrideTheme";
import { QuoteGuarantee } from "../quotePage/QuoteGuarantee";
import { QuotePackageQuery } from "../quotePage/QuotePackageQuery";
import { ReviewContainer } from "../quotePage/ReviewContainer";

const useStyles = makeStyles((theme) => ({
  root: {},
  alternate: {
    background: colors.alternate
  },
  button: {
    width: "90%",
    maxWidth: "17.5rem"
  },
  banner: {
    "backgroundSize": "cover",
    "backgroundPosition": "center",
    "width": "100%",
    "display": "flex",
    "alignItems": "center",
    "height": "120px",
    "backgroundImage": "url(images/sm/img-header-finance.jpg)",
    [theme.breakpoints.up("sm")]: {
      height: "210px"
    },
    [theme.breakpoints.up("md")]: {
      backgroundImage: "url(images/md/img-header-finance.jpg)",
      height: "360px"
    },
    [theme.breakpoints.up("lg")]: {
      backgroundImage: "url(images/lg/img-header-finance.jpg)"
    },
    [theme.breakpoints.up("xl")]: {
      backgroundImage: "url(images/xl/img-header-finance.jpg)"
    },
    "& h5": {
      maxWidth: "50%"
    }
  },
  requirementsImage: {
    objectFit: "cover",
    width: "100%"
  },
  humm: {
    maxWidth: "100%",
    maxHeight: "100px"
  }
}));

const strings = {
  "finance.header": "Buy Now Pay Later",
  "finance.flexifi.header": "Spread the Cost",
  "finance.flexifi.content.1": "Swyft Energy have teamed up with Humm so you can buy now and pay later.",
  "finance.flexifi.content.2":
    "You can spread your costs over 2 or 3 years. You can borrow the entire amount or a percentage of the cost and the process takes only about 10 minutes to complete. You can even pay out your purchase early without any additional fees or charges.  ",
  "finance.flexifi.content.3": "It’s all about you. ",

  "finance.flexifi.steps": "Just 4 simple steps",
  "finance.flexifi.step.1": "Select the Apply for Finance button",
  "finance.flexifi.step.2": "Enter the value that you wish to borrow",
  "finance.flexifi.step.3": "Enter your income and employment details",
  "finance.flexifi.step.4": "Humm will text you and let you know if your application was successful",

  "finance.flexifi.requirements.header": "What you need ",
  "finance.flexifi.requirements.1.header": "A government ID ",
  "finance.flexifi.requirements.1.text": "A passport or drivers licence. ",
  "finance.flexifi.requirements.2.header": "To be over 18 ",
  "finance.flexifi.requirements.2.text": "You must be over 18 years of age. ",
  "finance.flexifi.requirements.3.header": "Earn a minimum of €1,000 per month. ",
  "finance.flexifi.requirements.3.text": "Subject to terms and conditions for €500 and above. ",
  "finance.flexifi.requirements.4.header": "Supporting Documents ",
  "finance.flexifi.requirements.4.text":
    "You must provide evidence you earn over €1,000 per month. For example a payslip & bank statement. ",

  "finance.cta.header": "Start the process by choosing the Flexi-Fi option on your quote",
  "finance.cta.button": "Apply for finance"
};

export const FinancePage: React.FC = () => {
  const classes = useStyles();

  return (
    <div>
      <Box className={classes.banner}>
        <Container maxWidth="lg">
          <Typography variant="h5">{strings["finance.header"]}</Typography>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Box py={3}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="h2" paragraph>
                {strings["finance.flexifi.header"]}
              </Typography>
              <Typography variant="body2" paragraph>
                {strings["finance.flexifi.content.1"]}
              </Typography>
              <Typography variant="body2" paragraph>
                {strings["finance.flexifi.content.2"]}
              </Typography>
              <Typography variant="body2" paragraph>
                {strings["finance.flexifi.content.3"]}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src="images/humm.png" alt="Humm" className={classes.humm} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h2">{strings["finance.flexifi.steps"]}</Typography>
            </Grid>

            {FinanceStep("images/finance/img-step1-finance.png", strings["finance.flexifi.step.1"])}
            {FinanceStep("images/finance/img-step2-finance.png", strings["finance.flexifi.step.2"])}
            {FinanceStep("images/finance/img-step3-finance.png", strings["finance.flexifi.step.3"])}
            {FinanceStep("images/finance/img-step4-finance.png", strings["finance.flexifi.step.4"])}

            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" pb={3}>
                <Typography variant="body2">{strings["finance.cta.header"]}</Typography>
              </Box>
              <Box display="flex" justifyContent="center" pb={3}>
                <Button
                  href={"https://apply.flexifi.com/s/quote?src=0010Y00001Tl4JMQAZ&toURL=Quote"}
                  target="_blank"
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  {strings["finance.cta.button"]}
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box px={2}>
                <Typography variant="h2" paragraph>
                  {strings["finance.flexifi.requirements.header"]}
                </Typography>

                <Typography variant="h4">{strings["finance.flexifi.requirements.1.header"]}</Typography>
                <Typography variant="body1" paragraph>
                  {strings["finance.flexifi.requirements.1.text"]}
                </Typography>

                <Typography variant="h4">{strings["finance.flexifi.requirements.2.header"]}</Typography>
                <Typography variant="body1" paragraph>
                  {strings["finance.flexifi.requirements.2.text"]}
                </Typography>

                <Typography variant="h4">{strings["finance.flexifi.requirements.3.header"]}</Typography>
                <Typography variant="body1" paragraph>
                  {strings["finance.flexifi.requirements.3.text"]}
                </Typography>

                <Typography variant="h4">{strings["finance.flexifi.requirements.4.header"]}</Typography>
                <Typography variant="body1" paragraph>
                  {strings["finance.flexifi.requirements.4.text"]}
                </Typography>
              </Box>
            </Grid>

            <Hidden smDown>
              <Grid item md={6}>
                <img src="images/finance/img-banner-finance.jpg" alt="flexifi" className={classes.requirementsImage} />
              </Grid>
            </Hidden>
          </Grid>
        </Box>
      </Container>

      <Box mb={3} pb={3} className={classes.alternate}>
        <QuotePackageQuery />
      </Box>

      <Box py={3}>
        <OverrideTheme>
          <QuoteGuarantee />
        </OverrideTheme>
      </Box>

      <Box className={classes.alternate} mb={2} py={4} textAlign="center">
        <OverrideTheme>
          <ReviewContainer />
        </OverrideTheme>
      </Box>
    </div>
  );
};

const stepStyles = makeStyles((theme) => ({
  root: {
    boxShadow: boxShadow,
    padding: theme.spacing(2),
    minHeight: 175,
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      minHeight: 200
    },
    [theme.breakpoints.up("md")]: {
      minHeight: 235
    }
  },
  img: {
    height: 100
  }
}));

export function FinanceStep(img: string, text: string) {
  var classes = stepStyles();
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Box boxShadow={boxShadow} padding={3} className={classes.root}>
        <img src={img} alt="Step" className={classes.img} />
        <Typography variant="body1">{text}</Typography>
      </Box>
    </Grid>
  );
}
